export default __webpack_public_path__ + "static/media/a023-example3.e78fd1ca.png";